import React, { useState, useEffect, useContext } from "react";
//     import { defaultLogo } from "@ey-xd/motif-react/assets/images";
import {
  MotifHeader,
  MotifIcon,
  MotifIconButton,
  MotifVerticalNavigation as MotifVerticalNav,
  MotifVerticalNavigationContent as MotifVerticalNavContent,
  MotifVerticalNavigationMenu as MotifVerticalNavMenu,
  MotifVerticalNavigationMenuItem as MotifVerticalNavMenuItem,
  MotifVerticalNavigationSubmenu as MotifVerticalNavSubmenu,
  MotifDropdownPortal,
  MotifDropdownItem,
} from "@ey-xd/motif-react";

import {
  actionIcHome24px,
  mapsIcLocalActivity24px,
  actionIcFavorite24px,
  communicationIcBusiness24px,
  socialIcPerson24px,
  socialIcGroup24px,
  editorIcInsertChart24px,
  mapsIcLocalFlorist24px,
  notificationIcSms24px,
} from "@ey-xd/motif-react/assets/icons";

import logoEYGivEYrs from "./assets/svg/giveyrslogo.svg";
import megaphone from "./assets/svg/megaphone.svg";

// external libraries
import { Link, Navigate, Outlet, Route, Routes } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";

// pages
import { Home } from "./pages/Home";

import NewActivityPage from "./pages/activity/NewActivityPage";
import NewDonationPage from "./pages/donation/NewDonationPage";
import NewOrganizationPage from "./pages/organization/NewOrganizationPage";
import NewLandingPage from "./pages/landing/NewLandingPage";
import NewProBonosPage from "./pages/proBono/NewProBonosPage";
import NewUserPage from "./pages/users/NewUserPage";

import AllActivitiesPage from "./pages/activity/AllActivitiesPage";
import AllDonationsPage from "./pages/donation/AllDonationsPage";
import AllOrganizationsPage from "./pages/organization/AllOrganizationsPage";
import AllProBonosPage from "./pages/proBono/AllProBonosPage";
import AllLandingPage from "./pages/landing/AllLandingPage";
import AllUsersPage from "./pages/users/AllUsersPage";
import AllVolunteersPage from "./pages/AllVolunteersPage";

import EditActivityPage from "./pages/activity/EditActivityPage";
import EditOrganization from "./pages/organization/EditOrganization";
import EditProbono from "./pages/proBono/EditProbono";

import DuplicateActivityPage from "./pages/activity/DuplicateActivityPage";

import General from "./pages/reports/General";
import ProjectsReports from "./pages/reports/Projects";
import UsersReports from "./pages/reports/UsersReports";
import CategoriesReports from "./pages/reports/CategoriesReports";
import OrganizationsReports from "./pages/reports/Organizations";
import Volunteers from "./pages/reports/Volunteers";

import PushNotifications from "./pages/notifications/PushNotifications";

// providers
import LabelsProvider from "./context/LabelsProvider";
import LabelsContext from "./context/LabelsContext";

import {
  postLabels,
  getLabels,
  signInConsole,
  fetchUserData,
} from "./services/api";

import { UserInfoProvider } from "./context/UserInfo/UserInfoProvider";
import { EventInfoProvider } from "./context/EventInfo/EventInfoProvider";
import LandingPage from "./pages/landing/LandingPage";
import DonationPage from "./pages/donation/DonationPage";
import NewQuestionPage from "./pages/sustainability/NewQuestionPage";
import AllQuestionPage from "./pages/sustainability/AllQuestionsPage";
import QuestionPage from "./pages/sustainability/QuestionPage";
import ListActivityUsers from "./pages/activity/ListActivityUsersPage";
import Cookies from "js-cookie";
import { useGetToken } from "./globals";

export function App() {
  const setLabels = useContext(LabelsContext);
  const [labels, setGetLabels] = useState([]);
  const languages = [
    {
      code: "en",
      flag: "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIuMDAyIDUxMi4wMDIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMi4wMDIgNTEyLjAwMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBzdHlsZT0iZmlsbDojNDE0NzlCOyIgZD0iTTUwMy4xNzIsNDIzLjcyNUg4LjgyOGMtNC44NzUsMC04LjgyOC0zLjk1My04LjgyOC04LjgyOFY5Ny4xMDRjMC00Ljg3NSwzLjk1My04LjgyOCw4LjgyOC04LjgyOCAgaDQ5NC4zNDVjNC44NzUsMCw4LjgyOCwzLjk1Myw4LjgyOCw4LjgyOHYzMTcuNzkzQzUxMiw0MTkuNzcyLDUwOC4wNDcsNDIzLjcyNSw1MDMuMTcyLDQyMy43MjV6Ii8+CjxwYXRoIHN0eWxlPSJmaWxsOiNGNUY1RjU7IiBkPSJNNTEyLDk3LjEwNGMwLTQuODc1LTMuOTUzLTguODI4LTguODI4LTguODI4aC0zOS40OTVsLTE2My41NCwxMDcuMTQ3Vjg4LjI3NmgtODguMjc2djEwNy4xNDcgIEw0OC4zMjIsODguMjc2SDguODI4QzMuOTUzLDg4LjI3NiwwLDkyLjIyOSwwLDk3LjEwNHYyMi44MzFsMTQwLjMwOSw5MS45MjdIMHY4OC4yNzZoMTQwLjMwOUwwLDM5Mi4wNjZ2MjIuODMxICBjMCw0Ljg3NSwzLjk1Myw4LjgyOCw4LjgyOCw4LjgyOGgzOS40OTVsMTYzLjU0LTEwNy4xNDd2MTA3LjE0N2g4OC4yNzZWMzE2LjU3OGwxNjMuNTQsMTA3LjE0N2gzOS40OTUgIGM0Ljg3NSwwLDguODI4LTMuOTUzLDguODI4LTguODI4di0yMi44MzFsLTE0MC4zMDktOTEuOTI3SDUxMnYtODguMjc2SDM3MS42OTFMNTEyLDExOS45MzVWOTcuMTA0eiIvPgo8Zz4KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiNGRjRCNTU7IiBwb2ludHM9IjUxMiwyMjkuNTE4IDI4Mi40ODMsMjI5LjUxOCAyODIuNDgzLDg4LjI3NiAyMjkuNTE3LDg4LjI3NiAyMjkuNTE3LDIyOS41MTggMCwyMjkuNTE4ICAgIDAsMjgyLjQ4MyAyMjkuNTE3LDI4Mi40ODMgMjI5LjUxNyw0MjMuNzI1IDI4Mi40ODMsNDIzLjcyNSAyODIuNDgzLDI4Mi40ODMgNTEyLDI4Mi40ODMgICIvPgoJPHBhdGggc3R5bGU9ImZpbGw6I0ZGNEI1NTsiIGQ9Ik0xNzguOTQ4LDMwMC4xMzhMMC4yNSw0MTYuMTM1YzAuNjI1LDQuMjYzLDQuMTQsNy41OSw4LjU3Nyw3LjU5aDEyLjE1OWwxOTAuMzktMTIzLjU4NmgtMzIuNDI4ICAgVjMwMC4xMzh6Ii8+Cgk8cGF0aCBzdHlsZT0iZmlsbDojRkY0QjU1OyIgZD0iTTM0Ni4zODgsMzAwLjEzOEgzMTMuOTZsMTkwLjExMywxMjMuNDA0YzQuNDMxLTAuNDcyLDcuOTI4LTQuMDksNy45MjgtOC42NDZ2LTcuMjU4ICAgTDM0Ni4zODgsMzAwLjEzOHoiLz4KCTxwYXRoIHN0eWxlPSJmaWxsOiNGRjRCNTU7IiBkPSJNMCwxMDYuODQ5bDE2MS43NzksMTA1LjAxNGgzMi40MjhMNS4xNDMsODkuMTM3QzIuMTIzLDkwLjU0LDAsOTMuNTU1LDAsOTcuMTA0VjEwNi44NDl6Ii8+Cgk8cGF0aCBzdHlsZT0iZmlsbDojRkY0QjU1OyIgZD0iTTMzMi41NjYsMjExLjg2M0w1MTEuNjkzLDk1LjU4NmMtMC43NDQtNC4xMjItNC4xODQtNy4zMDktOC41MjEtNy4zMDloLTEyLjY0N0wzMDAuMTM4LDIxMS44NjMgICBIMzMyLjU2NnoiLz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K",
    },
    {
      code: "es",
      flag: "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",
    },
    {
      code: "pt",
      flag: "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",
    },
    {
      code: "fr",
      flag: "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxwYXRoIHN0eWxlPSJmaWxsOiM0MTQ3OUI7IiBkPSJNMTcwLjY2Nyw0MjMuNzIxSDguODI4Yy00Ljg3NSwwLTguODI4LTMuOTUzLTguODI4LTguODI4Vjk3LjFjMC00Ljg3NSwzLjk1My04LjgyOCw4LjgyOC04LjgyOCAgaDE2MS44MzlWNDIzLjcyMXoiLz4KPHJlY3QgeD0iMTcwLjY3IiB5PSI4OC4yNzciIHN0eWxlPSJmaWxsOiNGNUY1RjU7IiB3aWR0aD0iMTcwLjY3IiBoZWlnaHQ9IjMzNS40NSIvPgo8cGF0aCBzdHlsZT0iZmlsbDojRkY0QjU1OyIgZD0iTTUwMy4xNzIsNDIzLjcyMUgzNDEuMzMzVjg4LjI3M2gxNjEuODM5YzQuODc1LDAsOC44MjgsMy45NTMsOC44MjgsOC44Mjh2MzE3Ljc5MyAgQzUxMiw0MTkuNzcsNTA4LjA0Nyw0MjMuNzIxLDUwMy4xNzIsNDIzLjcyMXoiLz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==",
    },
    {
      code: "it",
      flag: "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxwYXRoIHN0eWxlPSJmaWxsOiM3M0FGMDA7IiBkPSJNMTcwLjY2Nyw0MjMuNzIxSDguODI4Yy00Ljg3NSwwLTguODI4LTMuOTUzLTguODI4LTguODI4Vjk3LjFjMC00Ljg3NSwzLjk1My04LjgyOCw4LjgyOC04LjgyOCAgaDE2MS44MzlWNDIzLjcyMXoiLz4KPHJlY3QgeD0iMTcwLjY3IiB5PSI4OC4yNzciIHN0eWxlPSJmaWxsOiNGNUY1RjU7IiB3aWR0aD0iMTcwLjY3IiBoZWlnaHQ9IjMzNS40NSIvPgo8cGF0aCBzdHlsZT0iZmlsbDojRkY0QjU1OyIgZD0iTTUwMy4xNzIsNDIzLjcyMUgzNDEuMzMzVjg4LjI3M2gxNjEuODM5YzQuODc1LDAsOC44MjgsMy45NTMsOC44MjgsOC44Mjh2MzE3Ljc5MyAgQzUxMiw0MTkuNzcsNTA4LjA0Nyw0MjMuNzIxLDUwMy4xNzIsNDIzLjcyMXoiLz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==",
    },
    /* {
      code: 'de',
      flag: "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIuMDAxIDUxMi4wMDEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMi4wMDEgNTEyLjAwMTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBzdHlsZT0iZmlsbDojNDY0NjU1OyIgZD0iTTUxMiwyMDAuMDkzSDBWOTcuMTA0YzAtNC44NzUsMy45NTMtOC44MjgsOC44MjgtOC44MjhoNDk0LjM0NWM0Ljg3NSwwLDguODI4LDMuOTUzLDguODI4LDguODI4ICBMNTEyLDIwMC4wOTNMNTEyLDIwMC4wOTN6Ii8+CjxwYXRoIHN0eWxlPSJmaWxsOiNGRkUxNUE7IiBkPSJNNTAzLjE3Miw0MjMuNzI1SDguODI4Yy00Ljg3NSwwLTguODI4LTMuOTUzLTguODI4LTguODI4VjMxMS45MDloNTEydjEwMi45ODggIEM1MTIsNDE5Ljc3Myw1MDguMDQ3LDQyMy43MjUsNTAzLjE3Miw0MjMuNzI1eiIvPgo8cmVjdCB5PSIyMDAuMDkxIiBzdHlsZT0iZmlsbDojRkY0QjU1OyIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIxMTEuODEiLz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=="
    },
    {
      code: 'nl',
      flag: "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIuMDAxIDUxMi4wMDEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMi4wMDEgNTEyLjAwMTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBzdHlsZT0iZmlsbDojRkY0QjU1OyIgZD0iTTUxMiwyMDAuMDkzSDBWOTcuMTA0YzAtNC44NzUsMy45NTMtOC44MjgsOC44MjgtOC44MjhoNDk0LjM0NWM0Ljg3NSwwLDguODI4LDMuOTUzLDguODI4LDguODI4ICBMNTEyLDIwMC4wOTNMNTEyLDIwMC4wOTN6Ii8+CjxwYXRoIHN0eWxlPSJmaWxsOiM0MTQ3OUI7IiBkPSJNNTAzLjE3Miw0MjMuNzI1SDguODI4Yy00Ljg3NSwwLTguODI4LTMuOTUzLTguODI4LTguODI4VjMxMS45MDloNTEydjEwMi45ODggIEM1MTIsNDE5Ljc3Myw1MDguMDQ3LDQyMy43MjUsNTAzLjE3Miw0MjMuNzI1eiIvPgo8cmVjdCB5PSIyMDAuMDkxIiBzdHlsZT0iZmlsbDojRjVGNUY1OyIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIxMTEuODEiLz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=="
    } */
  ];
  let selectedLanguage = sessionStorage.getItem("language") || "en";

  useEffect(() => {
    postLabels()
      .then(() => {
        console.log("Labels cargados correctamente");
      })
      .catch((error) => {
        console.error("Error al cargar labels:", error);
      });
    getLabels(selectedLanguage)
      .then((data) => {
        setGetLabels(data);
        setLabels(data);
      })
      .catch((error) => {
        console.error("Error al cargar labels:", error);
      });
  }, [setLabels, selectedLanguage]);
  console.log("labels", labels);
  const routes = [
    {
      label: labels?.labelList?.console_home_title,
      path: "/",
      icon: <MotifIcon src={actionIcHome24px} />,
    },

    {
      icon: <MotifIcon src={socialIcPerson24px} />,
      label: labels?.labelList?.console_profile_title,
      path: "/profile",
      subRoutes: [
        {
          label: labels?.labelList?.console_all_users,
          path: "/all-users",
        },
      ],
    },
    {
      icon: <MotifIcon src={socialIcGroup24px} />,
      label: labels?.labelList?.console_volunteers_title,
      path: "/volunteers",
      subRoutes: [
        {
          label: labels?.labelList?.console_all_volunteers,
          path: "/all-volunteers",
        },
        {
          label: labels?.labelList?.console_ranking,
          path: "/ranking",
        },
      ],
    },
    {
      icon: <MotifIcon src={mapsIcLocalActivity24px} />,
      label: labels?.labelList?.console_actions_title,
      path: "/actions",
      subRoutes: [
        {
          label: labels?.labelList?.console_all_actions,
          path: "/all-actions",
          icon: <MotifIcon src={megaphone} />,
        },
        {
          label: labels?.labelList?.console_create_new_action_menu,
          path: "/new-action",
          icon: <MotifIcon src={mapsIcLocalActivity24px} />,
        },
        {
          label: labels?.labelList?.console_all_probonos,
          path: "/all-probonos",
          icon: <MotifIcon src={megaphone} />,
        },
        {
          label: labels?.labelList?.console_create_new_probonos_menu,
          path: "/pro-bonos",
          icon: <MotifIcon src={mapsIcLocalActivity24px} />,
        },
      ],
    },
    {
      icon: <MotifIcon src={actionIcFavorite24px} />,
      label: labels?.labelList?.console_donations_title,
      path: "/donations",
      subRoutes: [
        {
          label: labels?.labelList?.console_all_donations,
          path: "/all-donations",
        },
        {
          label: labels?.labelList?.console_create_new_donation_menu,
          path: "/new-donation",
        },
      ],
    },
    {
      icon: <MotifIcon src={communicationIcBusiness24px} />,
      label: labels?.labelList?.console_organizations_title,
      path: "/organizations",
      subRoutes: [
        {
          label: labels?.labelList?.console_all_organizations,
          path: "/all-organizations",
        },
        {
          label: labels?.labelList?.console_create_new_organization_menu,
          path: "/new-organization",
        },
        {
          label: labels?.labelList?.console_all_landings,
          path: "/all-landings",
        },
        {
          label: labels?.labelList?.console_create_new_landing_menu,
          path: "/new-landing",
        },
      ],
    },
    {
      icon: <MotifIcon src={mapsIcLocalFlorist24px} />,
      label: labels?.labelList?.console_sustainability,
      path: "/sustainability",
      subRoutes: [
        {
          label: labels?.labelList?.console_all_questions,
          path: "/all-questions",
        },
        {
          label: labels?.labelList?.console_create_new_question_menu,
          path: "/new-question",
        },
      ],
    },
    {
      icon: <MotifIcon src={editorIcInsertChart24px} />,
      label: labels?.labelList?.console_reports_title,
      path: "/reports",
      subRoutes: [
        {
          label: labels?.labelList?.console_reports_general,
          path: "/general",
        },
        {
          label: labels?.labelList?.console_sl_reports,
          path: "/sl-reports",
        },
        {
          label: labels?.labelList?.console_reports_projects,
          path: "/actions-projects",
        },
        {
          label: labels?.labelList?.console_reports_categories,
          path: "/categories",
        },
        {
          label: labels?.labelList?.console_reports_organizations,
          path: "/organizations",
        },
      ],
    },
    {
      icon: <MotifIcon src={notificationIcSms24px} />,
      label: labels?.labelList?.console_notifications,
      path: "/notifications",
      subRoutes: [
        {
          label: labels?.labelList?.console_push_notifications,
          path: "/push-notifications",
        },
      ],
    },
  ];

  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  const [isOpen, setIsOpen] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState(
    routes[2].subRoutes[0].path
  );
  const [user, setUser] = useState(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  const setClickOutside = () => {
    setIsOpen(false);
  };
  let token = useGetToken();

  const initializeSignIn = () => {
    const accounts = instance.getAllAccounts();
    if (accounts.length === 0) {
      instance.loginRedirect();
    } else {
      token
        .then((accessToken) => {
          Cookies.set("token", accessToken, { expires: 1 / 24 });
        })
        .then(() => {
          if (Cookies.get("token") !== undefined) {
            signInConsole();
          } else {
            return <div>Authentication failure</div>;
          }
        })
        .then(() => {
          fetchUserData().then((userData) => {
            setUser(userData);
          });
        })
        .catch((error) => {
          console.error("Error retrieving token:", error);
        });
    }
  };

  useEffect(() => {
    initializeSignIn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const id = "dropdown-3";
  const triggerId = "dropdown-trigger-3";

  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);

  const handleToggleUserDropdown = () => {
    setIsUserDropdownOpen(!isUserDropdownOpen);
  };

  const handleUserDropdownClickOutside = () => {
    setIsUserDropdownOpen(false);
  };

  const handleUserDropdownItemClick = async () => {
    Cookies.get("token");
    await Cookies.remove("token");
    instance.logout();
  };

  const handleClickDropdownItem = (selectedLang) => {
    selectedLanguage = selectedLang;
    sessionStorage.setItem("language", selectedLanguage);
    setIsOpen(!isOpen);
  };

  const allLanguages = () => {
    return languages
      .filter((lang) => lang.code !== selectedLanguage)
      .map((lang) => (
        <MotifDropdownItem onClick={() => handleClickDropdownItem(lang.code)}>
          <MotifIcon src={lang.flag} /> {lang.code}
        </MotifDropdownItem>
      ));
  };
  const ProtectedRoute = ({ user, redirectPath = "/" }) => {
    if (!user || user.role === "CONTRIBUTOR") {
      return <Navigate to={redirectPath} replace />;
    }

    return <Outlet />;
  };
  const languageFlag = () => {
    return languages
      .filter((lang) => lang.code === selectedLanguage)
      .map((lang) => <MotifIcon src={lang.flag} />);
  };

  return (
    <>
      {!isAuthenticated && initializeSignIn()}
      {isAuthenticated && user?.role !== "REGULAR" ? (
        <LabelsProvider>
          <UserInfoProvider>
            <EventInfoProvider>
              <MotifHeader
                logo={<img src={logoEYGivEYrs} alt="GivEYrs" />}
                iconsContainer={
                  <>
                    <MotifIconButton
                      aria-label="Click to open menu"
                      type="button"
                      style={{ display: "none" }}
                    >
                      <span
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <MotifIcon src={socialIcPerson24px} />
                      </span>
                    </MotifIconButton>
                    <MotifDropdownPortal
                      open={isUserDropdownOpen}
                      placement="bottom-left"
                      id="user-dropdown-id"
                      aria-labelledby="user-dropdown-trigger-id"
                      handleClickOutside={handleUserDropdownClickOutside}
                      portalClassName="user-dropdown-classname"
                      trigger={
                        <MotifIconButton
                          aria-label="Click to open menu"
                          type="button"
                          onClick={handleToggleUserDropdown}
                          id="user-dropdown-trigger-id"
                        >
                          <MotifIcon src={socialIcPerson24px} />
                        </MotifIconButton>
                      }
                    >
                      <MotifDropdownItem
                        onClick={handleUserDropdownItemClick}
                        style={{ cursor: "pointer" }}
                      >
                        Log out
                      </MotifDropdownItem>
                    </MotifDropdownPortal>
                    <MotifDropdownPortal
                      open={isOpen}
                      placement="bottom-left"
                      id={id}
                      aria-labelledby={triggerId}
                      handleClickOutside={setClickOutside}
                      portalClassName="foobar"
                      trigger={
                        <MotifIconButton
                          aria-label="Click to open menu"
                          type="button"
                          onClick={handleToggle}
                          id={triggerId}
                        >
                          {languageFlag()}
                        </MotifIconButton>
                      }
                    >
                      {allLanguages()}
                    </MotifDropdownPortal>
                  </>
                }
                searchOpenCloseButtonProps={{
                  title: "Custom Search Button title",
                  "aria-label": "Custom Search Button aria-label",
                }}
              />
              <section className="main-container">
                <MotifVerticalNav collapse={true}>
                  <MotifVerticalNavContent>
                    <MotifVerticalNavMenu>
                      {routes.map((route) => {
                        if (route.subRoutes) {
                          return (
                            <MotifVerticalNavSubmenu
                              key={route.path}
                              icons={{ title: route.icon }}
                              selected={selectedRoute.startsWith(route.path)}
                              title={route.label}
                              className="submenu"
                            >
                              {route.subRoutes.map((subRoute) => (
                                <MotifVerticalNavMenuItem
                                  label={
                                    <>
                                      {subRoute.icon}
                                      {subRoute.label}
                                    </>
                                  }
                                  key={subRoute.path}
                                  selected={selectedRoute === subRoute.path}
                                  onClick={() =>
                                    setSelectedRoute(subRoute.path)
                                  }
                                >
                                  <Link
                                    className="routes"
                                    to={`${route.path}${subRoute.path}`}
                                  >
                                    {subRoute.label}
                                  </Link>
                                </MotifVerticalNavMenuItem>
                              ))}
                            </MotifVerticalNavSubmenu>
                          );
                        }
                        return (
                          <MotifVerticalNavMenuItem
                            icon={route.icon}
                            label={route.label}
                            key={route.path}
                            selected={selectedRoute === route.path}
                            onClick={() => setSelectedRoute(route.path)}
                          >
                            <Link className="routes" to={route.path}>
                              {route.label}
                            </Link>
                          </MotifVerticalNavMenuItem>
                        );
                      })}
                    </MotifVerticalNavMenu>
                  </MotifVerticalNavContent>
                </MotifVerticalNav>
                <section className="motif-container">
                  <div className="motif-container">
                    <div className="motif-row">
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route
                          path="/actions/new-action"
                          element={<NewActivityPage />}
                        />
                        <Route
                          path="/donations/new-donation"
                          element={<NewDonationPage />}
                        />
                        <Route
                          path="/actions/all-actions"
                          element={<AllActivitiesPage />}
                        />
                        <Route
                          path="/donations/all-donations"
                          element={<AllDonationsPage />}
                        />
                        <Route
                          path="/donations/edit-donation"
                          element={<DonationPage />}
                        />
                        <Route
                          path="/organizations/all-organizations"
                          element={<AllOrganizationsPage />}
                        />
                        <Route
                          path="/organizations/new-organization"
                          element={<NewOrganizationPage />}
                        />
                        <Route
                          path="/organizations/all-landings"
                          element={<AllLandingPage />}
                        />
                        <Route
                          path="/organizations/new-landing"
                          element={<NewLandingPage />}
                        />
                        <Route
                          path="/organizations/edit-landing"
                          element={<LandingPage />}
                        />
                        <Route
                          path="/actions/pro-bonos"
                          element={<NewProBonosPage />}
                        />
                        <Route
                          path="/actions/all-probonos"
                          element={<AllProBonosPage />}
                        />
                        <Route
                          path="/organizations/edit-organization/"
                          element={<EditOrganization />}
                        />
                        <Route
                          path="/probono/edit-probono/"
                          element={<EditProbono />}
                        />
                        <Route
                          path="/actions/edit-action/"
                          element={<EditActivityPage />}
                        />
                        <Route
                          path="/actions/duplicate-action"
                          element={<DuplicateActivityPage />}
                        />

                        <Route element={<ProtectedRoute user={user} />}>
                          <Route
                            path="/reports/general"
                            element={<General />}
                          />
                          <Route
                            path="/reports/actions-projects"
                            element={<ProjectsReports />}
                          />
                          <Route
                            path="/reports/sl-reports"
                            element={<UsersReports />}
                          />
                          <Route
                            path="/reports/categories"
                            element={<CategoriesReports />}
                          />
                          <Route
                            path="/reports/organizations"
                            element={<OrganizationsReports />}
                          />
                          <Route
                            path="/volunteers/ranking"
                            element={<Volunteers />}
                          />
                          <Route
                            path="/actions/volunteers-list"
                            element={<ListActivityUsers />}
                          />
                          <Route
                            path="/profile/all-users"
                            element={<AllUsersPage />}
                          />
                          <Route
                            path="/profile/new-user"
                            element={<NewUserPage />}
                          />
                          <Route
                            path="/volunteers/all-volunteers"
                            element={<AllVolunteersPage />}
                          />
                        </Route>
                        <Route
                          path="/sustainability/new-question"
                          element={<NewQuestionPage />}
                        />
                        <Route
                          path="/sustainability/all-questions"
                          element={<AllQuestionPage />}
                        />
                        <Route
                          path="/sustainability/edit-question"
                          element={<QuestionPage />}
                        />
                        <Route
                          path="/notifications/push-notifications"
                          element={<PushNotifications />}
                        />
                      </Routes>
                    </div>
                  </div>
                </section>
              </section>
            </EventInfoProvider>
          </UserInfoProvider>
        </LabelsProvider>
      ) : null}
    </>
  );
}
